(function () {
  'use strict';

  function parseJson(scope, selector) {
    var script = scope.querySelector(selector);
    if (!script) return {};
    try { return JSON.parse(script.textContent || '{}'); } catch (error) { return {}; }
  }

  function getVariantId(scope) {
    var select = scope.querySelector('select[name="id"]');
    var input = scope.querySelector('input[name="id"]');
    return String(select ? select.value : (input ? input.value : '') || '');
  }

  function setDeliveryState(output, valueNode, text) {
    text = String(text || '').trim();
    if (!text) {
      output.hidden = true;
      valueNode.textContent = '';
      output.classList.remove('SSVariantDeliveryTime--slow');
      return;
    }

    var numberMatch = text.match(/\d+(?:[.,]\d+)?/);
    var numericValue = numberMatch ? parseFloat(numberMatch[0].replace(',', '.')) : null;
    valueNode.textContent = text;
    output.hidden = false;
    output.classList.toggle('SSVariantDeliveryTime--slow', numericValue !== null && numericValue >= 10);
  }

  function setStockState(scope, variantId) {
    var output = scope.querySelector('[data-variant-low-stock]');
    var valueNode = scope.querySelector('[data-variant-low-stock-value]');
    if (!output || !valueNode) return;

    var data = parseJson(scope, '[data-variant-inventory-data]');
    var stock = variantId && data[variantId] ? data[variantId] : null;
    var quantity = stock ? Number(stock.quantity) : 0;
    var shouldShow = Boolean(stock && stock.tracked && quantity > 0 && quantity <= 5);

    if (!shouldShow) {
      output.hidden = true;
      valueNode.textContent = '';
      return;
    }

    valueNode.textContent = String(quantity);
    output.hidden = false;
  }

  function update(scope) {
    var output = scope.querySelector('[data-variant-delivery-time]');
    var valueNode = scope.querySelector('[data-variant-delivery-value]');
    var variantId = getVariantId(scope);

    if (output && valueNode) {
      var data = parseJson(scope, '[data-variant-delivery-data]');
      var variantText = variantId && Object.prototype.hasOwnProperty.call(data, variantId) ? String(data[variantId] || '').trim() : '';
      var productText = String(output.getAttribute('data-product-delivery-time') || '').trim();
      setDeliveryState(output, valueNode, variantText || productText);
    }

    setStockState(scope, variantId);
  }

  function init(scope) {
    if (!scope || scope.dataset.ssVariantDeliveryInitialized === 'true') return;
    if (!scope.querySelector('[data-variant-delivery-time]') && !scope.querySelector('[data-variant-low-stock]')) return;

    scope.dataset.ssVariantDeliveryInitialized = 'true';

    var scheduleUpdate = function () {
      window.requestAnimationFrame(function () { update(scope); });
    };

    scope.addEventListener('change', scheduleUpdate);
    scope.addEventListener('input', scheduleUpdate);
    scope.addEventListener('click', function (event) {
      if (event.target.closest('[data-single-option-selector], .SSVariantButton, .radio__button, .ProductForm__Option')) {
        window.setTimeout(scheduleUpdate, 0);
      }
    });

    update(scope);
  }

  function initAll() {
    document.querySelectorAll('.Product__Info, .Product, .Modal').forEach(init);
  }

  function updateAll() {
    document.querySelectorAll('.Product__Info, .Product, .Modal').forEach(update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:changed', updateAll);
  document.addEventListener('product:variant-changed', updateAll);
}());
